import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

// E8 8.6.2 / WI 579 — tracks unsaved-changes "dirty" flags per scope so useSignOut can confirm before
// signing the user out. Pages opt in via useDirtyState(true|false); a page that never calls it stays clean
// (no auto-detection). Multiple pages register independently under their own scope id.
export const DIRTY_STATE_REDUCER = 'dirtyState'

interface DirtyState {
  scopes: Record<string, boolean>
}

const initialState: DirtyState = { scopes: {} }

const dirtyStateSlice = createSlice({
  name: DIRTY_STATE_REDUCER,
  initialState,
  reducers: {
    setDirty(state, action: PayloadAction<string>) {
      state.scopes[action.payload] = true
    },
    clearDirty(state, action: PayloadAction<string>) {
      delete state.scopes[action.payload]
    },
  },
})

export const { setDirty, clearDirty } = dirtyStateSlice.actions

// True when ANY registered scope is dirty. Structurally typed (not RootState) to avoid a type cycle with
// the store, which composes this reducer; useAppSelector still accepts it (RootState is assignable).
export const selectIsAnyDirty = (state: { [DIRTY_STATE_REDUCER]: DirtyState }): boolean =>
  Object.values(state[DIRTY_STATE_REDUCER].scopes).some(Boolean)

export default dirtyStateSlice.reducer
